import axios from 'axios';

let prefix = "/system-variable"

const SystemVariableApi = {
	
	listSystemVariable(payload){
		return axios.get( prefix + "/list", {params: payload})
	},

	getSecuritySetting(payload){
		return axios.get( prefix + "/security-setting", {params: payload})
	},

	updateSecuritySetting(payload){
		return axios.post( prefix + "/update-security-setting", payload)
	},

	getPasswordSetting(payload){
		return axios.get( prefix + "/password-setting", {params: payload})
	},

	updatePasswordSetting(payload){
		return axios.post( prefix + "/update-password-setting", payload)
	},

	getPreAuthAmountSetting(payload){
		return axios.get( prefix + "/pre-auth-amount-setting", {params: payload})
	},

	updatePreAuthAmountSetting(payload){
		return axios.post( prefix + "/update-pre-auth-amount-setting", payload)
	},

	getCsNumberWsSetting(payload){
		return axios.get( prefix + "/cs-number-ws-setting", {params: payload})
	},

	updateCsNumberWsSetting(payload){
		return axios.post( prefix + "/update-cs-number-ws-setting", payload)
	},

	getDownloadUrl(payload){
		return axios.get( prefix + "/download-link", payload)
	},

	getLockAnimationDuration(payload){
		return axios.get( prefix + "/lock-animation-duration-setting", {params: payload})
	},

	updateLockAnimationDuration(payload){
		return axios.post( prefix + "/update-lock-animation-duration-setting", payload)
	},

	getAppVersionSetting(payload){
		return axios.get( prefix + "/app-version-setting", {params: payload})
	},

	updateAppVersionSetting(payload){
		return axios.post( prefix + "/update-app-version-setting", payload)
	},

}

export default SystemVariableApi;